import { Component, OnInit, Input, ChangeDetectorRef, SimpleChanges, OnDestroy } from '@angular/core';
import { PlayerService } from '../../services/player.service';
import { UserService } from '../../services/user.service';
import { DialogService } from '../../services/dialog.service';
import { GlobalService } from '../../services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'song-widget-v2',
    templateUrl: './song-widget-v2.component.html',
    styleUrls: ['./song-widget-v2.component.scss']
})
export class SongWidgetV2Component implements OnInit, OnDestroy {

    @Input() data: any;
    hovered: Boolean;
    tracks: any;
    tracksJson = [];
    type = '';
    album: any;
    itemNum = 0;
    from = '';
    fromForGA = '';
    for = '';
    label = '';
    sg = false;
    albumArtWidth = 250;

    trackSlugs = [];
    lyricsOpen: Boolean = false
    imageBgColor = '';
    currentSlug: any;
    slug = '';
    musicVideoLoaded = false;
    musicVideo = [];
    musicVideoalbums = [];
    musicVideosong = [];
    currentSlugLyrics = '';
    multiArt: any;
    selectedSlug: any;
    multislug: any = [];
    //lyricslen=0;

    constructor(
        public player: PlayerService,
        public user: UserService,
        public dialog: DialogService,
        public global: GlobalService,
        private api: ApiService,
        private router: Router,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private cd: ChangeDetectorRef
    ) {
        this.route.params.subscribe(res => {
            if (res.slug) {
                this.slug = res.slug.split('?')[0];
                //this.getMusicVideo('',this.slug);
            }
        });
        this.route.queryParams.subscribe(params => {
            // //console.log(params.trackSlug);
            this.selectedSlug = params.trackSlug;
            // //console.log(this.selectedSlug)
        });

        this.player.slugSubject.subscribe(res => {
            this.currentSlug = res;

        })
        this.player.slugSubjectLyrics.subscribe((res: any) => {
            this.currentSlugLyrics = res ? res.replace(/(style=")(.*)(")/gi, '') : res;
            this.currentSlugLyrics = this.currentSlugLyrics.replace(/(?:\r\n|\r|\n)/g, '<br>');
            //console.log(res)
        })

    }


    ngOnInit() {
        // //console.log(this.data.multiArt);
        this.multiArt = this.data.multiArt;
        if (this.data.multiArt) {
            this.multiArt.forEach(item => {
                this.multislug.push(item.slug_username)

            });
        }


        if (typeof (this.data.for) !== undefined) {
            this.for = this.data.for;
            this.label = this.data.label;
        }
        if (typeof (this.data.sg) !== undefined) {
            this.sg = this.data.sg;
        }
        if (this.data.from != '' && this.data.from != undefined && this.data.from != null) {
            this.from = this.data.from;
            this.fromForGA = this.from + ' ' + this.router.url;
        } else {
            this.fromForGA = this.router.url;
        }

        if (this.for == 'spotlight') {
            this.albumArtWidth = 350;
        }

        if (!this.data.skeletonLoading) {
            this.type = this.data.type;
            if (this.data.itemNum != undefined) {
                this.itemNum = this.data.itemNum;
            }

            if (this.type == 'album') {

                if (this.data.new) {
                   

                    this.tracks = this.data.album.album_tracks;
                    let multi = 0
                    if (this.data.multiArt){
                        multi = this.data.multiArt.length;
                    }

                    this.album = {
                        'title': this.data.album.title,
                        'agreement': this.data.album.agreement,
                        'artist': this.data.album.name,
                        'artistSlug': this.data.album.artist_slug,
                        'artistDp': this.data.album.profile_pic,
                        'image': this.data.album.image,
                        'slug': (this.data.album.is_album > 0) ? this.data.album.album_slug : this.data.album.song_slug,
                        'is_album': this.data.album.is_album,
                        'isSameArtist': this.data.album.is_same_artist,
                        'clapsCount': this.data.album.user_claps,
                        'totalClapsCount': this.data.album.song_claps,
                        'isDownloadable': this.data.album.is_downloadable,
                        'isPaid': this.data.album.is_paid,
                        'buylink': this.data.album.song_buylink,
                        'price': this.data.album.price,
                        'sku': this.data.album.sku,
                        'totalDuration': this.global.sec2Min(this.data.album.duration),
                        'plays': this.data.album.song_plays,
                        'multiArt': this.data.multiArt,
                        'isVariousArtists': multi > 1 ? true : false,

                    };
            

                } else {
                    //console.log(this.data)
                    this.tracks = this.data.album.music_tracks;

                    this.album = {
                        'title': this.data.album.title,
                        'agreement': this.data.album.agreement,
                        'artist': this.data.album.artists[0].full_name,
                        'artistSlug': this.data.album.artists[0].slug_username,
                        'image': this.data.album.cover_pic,
                        'slug': (this.data.album.is_album > 0) ? this.data.album.album_slug : this.data.album.song_slug,
                        'is_album': this.data.album.is_album,
                        'isSameArtist': this.data.album.artists[0].is_same_artist,
                        'clapsCount': this.data.album.is_like,
                        'totalClapsCount': this.data.album.likes_count,
                        'isDownloadable': this.data.album.is_digital,
                        'isPaid': (this.data.album.album_price > 0) ? true : false,
                        'buylink': this.data.album.buy_link,
                        'price': this.data.album.album_price,
                        'sku': this.data.album.sku,
                        'totalDuration': this.global.sec2Min(this.data.album.total_duration),
                        'plays': this.data.album.play_count,
                        'isVariousArtists': this.data.album.various_art
                    };
             

                }
            } else if (this.type == 'playlist') {
                this.tracks = this.data.playlist.track;
                ////console.log("-------kailash2-----------")


                let image = this.data.playlist.cover_pic;
                if ((image == '' || image == null) &&
                    this.tracks.length > 0 &&
                    (this.tracks[0].image != '' && this.tracks[0].image != null)
                ) {
                    image = this.tracks[0].image;
                }

                this.album = {
                    'title': this.data.playlist.title,
                    'agreement': '',
                    'artist': '',
                    'artistSlug': '',
                    'description': this.data.playlist.description,
                    'image': image,
                    'slug': this.data.playlist.slug_playlist,
                    'isSameArtist': this.data.playlist.is_same_artist,
                    'clapsCount': this.data.playlist.is_like,
                    'totalClapsCount': this.data.playlist.playlist_likes,
                    'isDownloadable': false,
                    'totalDuration': this.global.sec2Min(this.data.playlist.playlist_duration),
                    'plays': this.data.playlist.playlist_plays,
                    'isVariousArtists': false,



                };
            } else if (this.type == 'playlist-listing') {
                this.tracks = this.data.playlist.track;
                ////console.log("-------kailash2-----------")


                let image = this.data.playlist.img;
                if ((image == '' || image == null) &&
                    this.tracks.length > 0 &&
                    (this.tracks[0].image != '' && this.tracks[0].image != null)
                ) {
                    image = this.tracks[0].image;
                }

                this.album = {
                    'title': this.data.playlist.title,
                    'agreement': '',
                    'artist': '',
                    'artistSlug': '',
                    'description': '',
                    'image': image,
                    'slug': this.data.playlist.slug,
                    'isSameArtist': '',
                    'clapsCount': this.data.playlist.is_like,
                    'totalClapsCount': this.data.playlist.playlist_likes,
                    'isDownloadable': false,
                    'totalDuration': this.global.sec2Min(this.data.playlist.playlist_duration),
                    'plays': this.data.playlist.playlist_plays,
                    'isVariousArtists': false,



                };
            } else {
                this.tracks = this.data.tracks;
                //console.log("-------kailash3-----------", this.data.agreement)

                if (this.data.new) {
                    this.album = {
                        'title': this.tracks[this.itemNum].title,
                        'agreement': this.data.agreement,
                        'artist': this.tracks[this.itemNum].name,
                        'artistSlug': this.tracks[this.itemNum].artist_slug,
                        'artistDp': this.tracks[this.itemNum].profile_pic,
                        'image': this.tracks[this.itemNum].image,
                        'is_album': this.tracks[this.itemNum].is_album,
                        'slug': (this.tracks[this.itemNum].is_album > 0) ? this.tracks[this.itemNum].album_slug : this.tracks[this.itemNum].song_slug,
                        'songSlug': this.tracks[this.itemNum].song_slug,
                        'isSameArtist': this.tracks[this.itemNum].is_same_artist,
                        'clapsCount': this.tracks[this.itemNum].user_claps,
                        'totalClapsCount': this.tracks[this.itemNum].song_claps,
                        'isDownloadable': this.tracks[this.itemNum].is_downloadable,
                        'isPaid': this.tracks[this.itemNum].is_paid,
                        'buylink': this.tracks[this.itemNum].song_buylink,
                        'price': this.tracks[this.itemNum].price,
                        'sku': this.tracks[this.itemNum].sku,
                        'totalDuration': this.global.sec2Min(this.tracks[this.itemNum].duration),
                        'plays': this.tracks[this.itemNum].song_plays,
                        'lyrics': this.tracks[this.itemNum].lyrics,
                        'isVariousArtists': false,

                    };
                } else if (this.data.structure == 3) {

                    this.album = {
                        'title': this.tracks[this.itemNum].title,
                        'agreement': this.data.agreement,
                        'artist': this.tracks[this.itemNum].artist_id.profile.first_name + ' ' + this.tracks[this.itemNum].artist_id.profile.last_name,
                        'artistSlug': this.tracks[this.itemNum].artist_id.slug_username,
                        'image': this.tracks[this.itemNum].image,
                        'is_album': this.tracks[this.itemNum].is_album,
                       // 'slug': this.tracks[this.itemNum].slug_usersong,
                        'slug': (this.tracks[this.itemNum].is_album ) ? this.tracks[this.itemNum].album.slug_album : this.tracks[this.itemNum].slug_usersong,

                        'songSlug': this.tracks[this.itemNum].slug_usersong,
                        'isSameArtist': this.tracks[this.itemNum].is_same_artist,
                        'clapsCount': this.tracks[this.itemNum].is_like,
                        'totalClapsCount': this.tracks[this.itemNum].song_likes,
                        'isDownloadable': this.tracks[this.itemNum].is_downloadable,
                        'isPaid': this.tracks[this.itemNum].is_paid,
                        'buylink': this.tracks[this.itemNum].buylink,
                        'price': this.tracks[this.itemNum].price,
                        'sku': this.tracks[this.itemNum].sku,
                        'totalDuration': this.global.sec2Min(this.tracks[this.itemNum].duration),
                        'plays': this.tracks[this.itemNum].song_plays,
                        'lyrics': this.tracks[this.itemNum].lyrics,
                        'isVariousArtists':  false,

                    };

                   
                } else if (this.data.detailPageTracks || this.data.structure == 2) {


                    this.album = {
                        'title': this.tracks[this.itemNum].title,
                        'agreement': this.data.agreement,
                        'artist': this.tracks[this.itemNum].artist_id.profile.first_name + ' ' + this.tracks[this.itemNum].artist_id.profile.last_name,
                        'artistSlug': this.tracks[this.itemNum].artist_id.slug_username,
                        'image': this.tracks[this.itemNum].image,
                        'is_album': this.tracks[this.itemNum].is_album,
                        'slug': this.tracks[this.itemNum].slug_usersong,
                        'songSlug': this.tracks[this.itemNum].song_slug,
                        'isSameArtist': this.tracks[this.itemNum].is_same_artist,
                        'clapsCount': this.tracks[this.itemNum].is_like,
                        'totalClapsCount': this.tracks[this.itemNum].song_likes,
                        'isDownloadable': this.tracks[this.itemNum].is_downloadable,
                        'isPaid': this.tracks[this.itemNum].is_paid,
                        'buylink': this.tracks[this.itemNum].buylink,
                        'price': this.tracks[this.itemNum].price,
                        'sku': this.tracks[this.itemNum].sku,
                        'totalDuration': this.global.sec2Min(this.tracks[this.itemNum].duration),
                        'plays': this.tracks[this.itemNum].song_plays,
                        'lyrics': this.tracks[this.itemNum].lyrics,
                        'isVariousArtists':  false,

                    };
                   
                }  else {
                    this.album = {
                        'title': (this.tracks[this.itemNum][0].is_album > 0) ? this.tracks[this.itemNum][0].album_title : this.tracks[this.itemNum][0].title,
                        'agreement': (this.tracks[this.itemNum][0].is_album > 0) ? this.tracks[this.itemNum][0].agreement : this.tracks[this.itemNum][0].agreement,
                        'artist': this.tracks[this.itemNum][1].full_name,
                        'artistSlug': this.tracks[this.itemNum][1].slug_username,
                        'artistDp': this.tracks[this.itemNum][1].profile_pic,
                        'image': (this.tracks[this.itemNum][0].is_album > 0) ? this.tracks[this.itemNum][0].album.cover_pic : this.tracks[this.itemNum][0].image,
                        'is_album': this.tracks[this.itemNum][0].is_album,
                        'slug': (this.tracks[this.itemNum][0].is_album > 0) ? this.tracks[this.itemNum][0].album_slug : this.tracks[this.itemNum][0].song_slug,
                        'isSameArtist': this.tracks[this.itemNum][0].is_same_artist,
                        'clapsCount': this.tracks[this.itemNum][0].is_like,
                        'totalClapsCount': this.tracks[this.itemNum][0].song_likes,
                        'isDownloadable': this.tracks[this.itemNum][0].is_downloadable,
                        'isPaid': this.tracks[this.itemNum][0].is_paid,
                        'buylink': this.tracks[this.itemNum][0].buylink,
                        'price': this.tracks[this.itemNum][0].song_price,
                        'sku': this.tracks[this.itemNum][0].sku,
                        'totalDuration': this.global.sec2Min(this.tracks[this.itemNum][0].duration),
                        'plays': this.tracks[this.itemNum][0].song_plays,
                        'lyrics': this.tracks[this.itemNum][0].lyrics,
                        'isVariousArtists':  false,


                    };

                }


                //this.lyricslen=this.album.lyrics.length;
                //////console.log(this.lyricslen);

                if ((this.album.image == '' || this.album.image == null || this.album.image == undefined) &&
                    this.tracks[this.itemNum].album != null
                ) {
                    this.album.image = this.tracks[this.itemNum].album.cover_pic;
                }
            }

            let trackNum = 0;
            if(this.tracks){
                this.tracks.forEach(track => {
                    if (this.type == 'album') {
                        if (this.data.new) {
                            this.tracksJson.push({
                                'title': track.name,
                                'artist': this.data.album.name,
                                'artistSlug': this.data.album.artist_slug,
                                'mp3': track.file,
                                'm4a': track.file,
                                'image': this.data.album.image,
                                'slug': track.slug,
                                'clapsCount': track.is_like,
                                'totalClapsCount': track.song_likes
                            });

                            this.tracks[trackNum].image = this.data.album.cover_pic;
                            this.tracks[trackNum].title = this.tracks[trackNum].name;
                            this.tracks[trackNum].slug_usersong = this.tracks[trackNum].slug;
                        } else {
                            this.tracksJson.push({
                                'title': track.name,
                                'artist': this.album.artist,
                                'artistSlug': this.album.artistSlug,
                                'mp3': track.song_file,
                                'm4a': track.song_file,
                                'image': this.data.album.image,
                                'slug': track.slug_usersong,
                                'clapsCount': track.is_like,
                                'totalClapsCount': track.song_likes
                            });

                            this.tracks[trackNum].image = this.data.album.cover_pic;

                            if (this.for == 'spotlight') {
                                this.tracksJson[trackNum].image = track.album.cover_pic;
                                this.tracksJson[trackNum].title = track.title;
                            }
                        }
                    } else if (this.type == 'playlist') {
                        /*
                        this.tracksJson.push({
                            'title': track.title,
                            'artist': track.artist_id.full_name,
                            'artistSlug': track.artist_id.slug_username,
                            'mp3': track.song_file,
                            'm4a': track.song_file,
                            'image': track.image,
                            'slug': track.slug_usersong,
                            'clapsCount': track.is_like,
                            'totalClapsCount': track.song_likes
                        }); */
                        this.tracksJson.push({
                            'title': track.title,
                            'artist': (track.artist_id != undefined && track.artist_id != null) ? track.artist_id.full_name : '',
                            'artistSlug': (track.artist_id != undefined && track.artist_id != null) ? track.artist_id.slug_username : '',
                            'mp3': track.song_file,
                            'm4a': track.song_file,
                            'image': track.image,
                            'slug': track.slug_usersong,
                            'clapsCount': 0,
                            'totalClapsCount': 0
                        });

                        if (track.album_id > 0 &&
                            (track.album != '' && track.album != null && track.album != undefined) &&
                            (track.album.cover_pic != '' && track.album.cover_pic != null && track.album.cover_pic != undefined)
                        ) {
                            this.tracks[trackNum].image = track.album.cover_pic;
                            this.tracksJson[trackNum].image = track.album.cover_pic;
                        }
                    } else {
                        if (this.data.new) {
                            this.tracksJson.push({
                                'title': track.title,
                                'artist': track.name,
                                'artistSlug': track.artist_slug,
                                'mp3': track.song,
                                'm4a': track.song,
                                'image': track.image,
                                'slug': track.song_slug,
                                'clapsCount': track.user_claps,
                                'totalClapsCount': track.song_claps
                            });
                        } else if (this.data.detailPageTracks || this.data.structure == 2 || this.data.structure == 3) {
                            this.tracksJson.push({
                                'title': track.title,
                                'artist': track.artist_id.profile.first_name + ' ' + track.artist_id.profile.last_name,
                                'artistSlug': track.artist_id.slug_username,
                                'mp3': track.song_file,
                                'm4a': track.song_file,
                                'image': track.image,
                                'slug': track.slug_usersong,
                                'clapsCount': track.is_like,
                                'totalClapsCount': track.song_likes
                            });
                        } else {
                            this.tracksJson.push({
                                'title': track[0].title,
                                'artist': track[1].full_name,
                                'artistSlug': track[1].slug_username,
                                'mp3': track[0].song_file,
                                'm4a': track[0].song_file,
                                'image': track[0].image,
                                'slug': track[0].slug_usersong,
                                'clapsCount': track[0].is_like,
                                'totalClapsCount': track[0].song_likes
                            });
                        }

                        const image = this.tracksJson[trackNum].image;
                        if (track.album_id > 0 &&
                            (track.album != '' && track.album != null && track.album != undefined) &&
                            (track.album.cover_pic != '' && track.album.cover_pic != null && track.album.cover_pic != undefined)
                        ) {
                            this.tracks[trackNum].image = track.album.cover_pic;
                            this.tracksJson[trackNum].image = track.album.cover_pic;
                        }
                    }

                    trackNum++;
                });

                if (this.type == 'album' || this.type == 'playlist') {
                    this.tracksJson.forEach(element => {
                        this.trackSlugs.push(element.slug);
                    });
                } else {
                    this.trackSlugs.push(this.album.slug);
                }
            }
        }

        if (this.player.currentSlug) {
            this.currentSlug = this.player.currentSlug;
        }
        // if (this.player.currentItemlyrics) {
        //     this.currentSlugLyrics = this.player.currentItemlyrics;
        // }
    }

    getMusicVideo(slug_album, slug_usersong) {
        //////console.log('a');
        this.api.getMusicVideo(slug_album, slug_usersong).subscribe(res => {
            if (res.success) {
                this.musicVideoLoaded = true;
                this.musicVideo = res;
                this.musicVideoalbums = res.album;
                this.musicVideosong = res.song;
                ////console.log(this.musicVideosong);
                ////console.log(this.musicVideoalbums);
            }
            else {
                //////console.log("error");
            }
        },
            (err: HttpErrorResponse) => {
                this.musicVideoLoaded = false;
                if (err.error instanceof Error) {
                    // ////console.log('Client-side error occured!');
                } else {
                    // ////console.log('Server-side error occured!', err);
                }
            });
    }

    async ngAfterViewInit() {
        if (this.global.isBrowser) {
            const Vibrant = require('node-vibrant');

            try {
                const colorVibrantObject = new Vibrant(this.album.image);
                const colorMap = await colorVibrantObject.getPalette();
                this.imageBgColor = colorMap.DarkMuted.hex;
            } catch (error) {
                // ////console.log(error);
            }
        }
    }

  
    editSong() {
        if (this.type == '') {
            this.router.navigate(['/upload/song'], { queryParams: { slug: this.album.slug } });
        } else if (this.type == 'album') {
            this.router.navigate(['/upload/album/'], { queryParams: { slug: this.album.slug }});
        } else if (this.type == 'playlist') {
            this.router.navigate(['/edit-playlist'], { queryParams: { slug: this.album.slug } });
        }
    }





    imageLoaded(event) {
        // ////console.log(event);
    }



    navigateToDetailPage() {
        if (this.type === '') {
            this.router.navigate(['/songs/' + this.album.slug]);
        } else if (this.type === 'album') {
            this.router.navigate(['/albums/' + this.album.slug]);
        } else if (this.type === 'playlist') {
            this.router.navigate(['/playlists/' + this.album.slug]);
        }
    }


    navigate(slug, track) {
        this.router.navigate(['/albums/' + slug],
            { queryParams: { trackSlug: track } })
    }






    flagl = 0;
    flagv = 0;

    get getScreenwidth() {
        return screen.width > 750
    }

    get isMobile() {
        return screen.width < 767;
    }

    get shouldShowPopUp() {
        return screen.width > 750; //((this.currentSlug == this.album.slug) && this.player.playing && this.isMobile) ? false : true
    }
    showTrue: boolean = false;
    removepop() {
        if (screen.width < 750) {
            this.showTrue = false;
            document.getElementById('mobilepopup').style.display = "none";
            document.getElementById('coverup').style.display = "none";
            document.body.style.overflowY = "auto";
        }
    }
    addpop() {
        if (screen.width < 750) {
            this.showTrue = true;
            setTimeout(() => {
                document.getElementById('mobilepopup').style.display = "block";
                document.getElementById('coverup').style.display = "block";
                // document.getElementById('trackdropdown').style.display = "block";
            }, 300);
            document.body.style.overflowY = "hidden";
        }
    }
    lyricspop() {
        let content = document.getElementById('mpoplcontent');
        let change = document.getElementById('imgchanger1');
        if (this.flagl == 0) {
            this.flagl = 1;
            content.style.display = "block";
        }
        else if (this.flagl == 1) {
            this.flagl = 0;
            content.style.display = "none";
        }
    }
    videopop() {
        let content = document.getElementById('mpopvcontent');
        let change = document.getElementById('imgchanger2');
        if (this.flagv == 0) {
            this.flagv = 1;
            content.style.display = "block";
        }
        else if (this.flagv == 1) {
            this.flagv = 0;
            content.style.display = "none";
        }
    }
    artistPop() {
        let content = document.getElementById('severalArtist');
        let change = document.getElementById('imgchanger3');
        if (this.flagv == 0) {
            this.flagv = 1;
            content.style.display = "block";
        }
        else if (this.flagv == 1) {
            this.flagv = 0;
            content.style.display = "none";
        }
    }
    showlyrics(idd) {
        let lyrics = document.getElementById(idd);
        lyrics.style.overflow = "none";
        lyrics.style.textOverflow = "clip";
        lyrics.style.display = "block"
        // lyrics.style.maskImage = "linear-gradient(to bottom, black, black)";
        lyrics.style.webkitMaskImage = "linear-gradient(to bottom, black, black)";
        document.getElementById('fhide').style.display = "none";
        this.lyricsOpen = true;
    }
    hideLyrics(idd) {
        let lyrics = document.getElementById(idd);
        lyrics.style.overflow = "auto";
        lyrics.style.textOverflow = "clip";
        lyrics.style.display = "-webkit-box"
        lyrics.style.height = "auto";
        lyrics.style.textOverflow = "ellipsis";
        lyrics.style.webkitLineClamp = "4";
        lyrics.style.webkitBoxOrient = "vertical";
        lyrics.style.webkitMaskImage = "linear-gradient(to bottom, black 50%, transparent 100%)";
        // this.lyricsBtnHide = true;
        this.global.scrollToTop();
        this.lyricsOpen = false;

    }


    getUrl(post) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(post);
    }

    sendCoundBack() {
        if (this.album.clapsCount < 50) {
            this.player.countClaps.next(true);
        }
    }

    followAll(task = 'follow', type = 'single', slug) {
        //console.log(type, task, slug)
        //console.log(this.multiArt)


        this.api.followArtist(type == "multiple" ? this.multislug : slug, task).subscribe(res => {
            if (type == 'single') {

                for (var i in this.multiArt) {

                    if (this.multiArt[i].username == slug) {
                        if (task == 'follow') {
                            this.multiArt[i].following = true;

                        } else {
                            this.multiArt[i].following = false;

                        }
                        break;
                    }
                }

            }

        },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    // //console.log('Client-side error occured!');
                } else {
                    // //console.log('Server-side error occured!', err);
                }

                if (task == 'follow') {
                    // this.isFollowing = false;
                    // this.artist.followers_count--;
                } else {
                    // this.isFollowing = true;
                    // this.artist.followers_count++;
                }
            });
    }

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        // if (this.player.slugSubjectLyrics)
        //     this.player.slugSubjectLyrics.unsubscribe();
        // if (this.player.slugSubject)
        //     this.player.slugSubject.unsubscribe();
    }

}
